const types = {
    14: 'DriverLicense',
    5: 'EducationHistory',
    8: 'Employments',
    9: 'ExpectedSalary',
    11: 'Gender',
    6: 'Languages',
    10: 'RecommendingPerson',
    7: 'WorkExperience',
    15: 'Availability',
    12: 'Birthday',
    17: 'WorkLocations'
};
export default types;